import { OrganizationStepProps } from '@/libs/onboarding';
import styles from './OrganizationList.module.css';
import { Empty, Icon, LoadingProgress } from '@oolio-group/design-ui-react';
import { DeviceConfigHeader } from '../common/DeviceConfigHeader';
import { ErrorMessage } from '@/components/error-message/ErrorMessage';

export const OrganizationList = ({
  organizations,
  loading,
  error,
  onSelect,
  onRetry,
}: OrganizationStepProps) => {
  const renderContent = () => {
    if (loading) {
      return <LoadingProgress color="var(--accent)" loading />;
    }

    if (error) {
      return <ErrorMessage message={error} onRetry={onRetry} />;
    }

    if (!organizations || organizations.length === 0) {
      return <Empty label="No organizations found." />;
    }

    return (
      <>
        <div className={styles.locationsList}>
          {organizations.map(org => (
            <button
              className={styles.storeItem}
              key={org.id}
              onClick={() => onSelect(org)}
            >
              <span className={styles.storeIcon}>
                <Icon name="building" />
              </span>
              <span className={styles.storeName}>{org.name}</span>
            </button>
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <DeviceConfigHeader title="Select an organization to continue..." />
      <div className={styles.contentContainer}>{renderContent()}</div>
    </>
  );
};
